import { makeStyles } from '@material-ui/core'
import { IStyleProps } from './Interface'

export default makeStyles<{}, IStyleProps>({
  autocomplete: {
    width: '100%',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  formControl: {
    width: '100%',
    paddingTop: 5,
    margin: '8px 0',
    position: 'relative',
    '& .MuiInputLabel-root': {
      width: 'max-content'
    }
  },
  inputRoot: ({ alwaysEnabled }) => ({
    borderRadius: 50,
    border: '1px solid #ced4da',
    flex: 1,
    '&::before': {
      display: 'none'
    },
    '&::after': {
      display: 'none'
    },
    ...(alwaysEnabled
      ? {}
      : {
          '&:not(:focus-within)': {
            border: 'none',
            '& .MuiAutocomplete-endAdornment': {
              display: 'none'
            }
          },
          '&:hover:not(:focus-within)': {
            background: '#EDEBEB',
            '& .MuiAutocomplete-input': {
              background: '#EDEBEB'
            }
          },
          '&.Mui-disabled:hover': {
            background: 'unset'
          },
          '&.Mui-disabled:hover .MuiAutocomplete-input': {
            background: 'unset',
            cursor: 'text'
          }
        })
  }),
  searchInput: {
    borderRadius: 25,
    position: 'relative',
    backgroundColor: 'white',
    fontSize: 14,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    boxShadow: 'none',
    padding: '5px 25px',
    '&:focus': {
      borderColor: '#3700D7'
    },
    '&::placeholder': {
      fontSize: 14
    }
  },
  multiline: {
    padding: 0,
    '& textarea': {
      minHeight: 41,
      boxSizing: 'border-box'
    }
  },
  popper: {
    display: ({ searchTerm }) => (searchTerm?.length >= 3 ? 'initial' : 'none')
  }
})
